// i18n area 'cluster' — locale uk-UA (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.uk-UA.meta.json.
import type { enUS } from './cluster'

export const ukUA: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Гарантійні доступи',
      subtitle: 'Сервісні двері вузла: доступ лише для читання з тимчасовим паролем і аварійний обліковий запис із паролем із сейфа',
      readOnlyTitle: 'Доступ лише для читання (trantor)',
      stateNone: 'закрито',
      stateGranted: 'відкрито',
      stateGrantedPending: 'надано — застосовується на вузлі',
      grantedBy: 'Надав',
      grantedAt: 'Надано',
      expiresAt: 'Закінчується',
      reason: 'Причина',
      endedAt: 'Закрито',
      endedReason: {
        revoked: 'відкликано',
        expired: 'закінчився (TTL)',
        reboot: 'перезавантаження вузла',
        failed: 'не застосовано (завдання не вдалося)'
      },
      grant: 'Надати доступ лише для читання…',
      grantTitle: 'Надати доступ лише для читання',
      grantSubmit: 'Надати',
      grantError: 'Надання відхилено',
      grantConfirm: 'TVirt генерує тимчасовий пароль для системного користувача «trantor» (лише читання: journal і діагностика, без sudo) і встановлює його на вузлі завданням. Пароль показується ЛИШЕ один раз, під час підтвердження; він припиняє діяти після закінчення терміну, після відкликання або при наступному перезавантаженні вузла.',
      reasonLabel: 'Причина',
      reasonHint: 'Чому ви відчиняєте двері: це залишається в наданні, в аудиті та в журналі',
      ttlLabel: 'Тривалість',
      ttlHours: '{n} год',
      revoke: 'Відкликати доступ лише для читання…',
      revokeTitle: 'Відкликати доступ лише для читання',
      revokeSubmit: 'Відкликати',
      revokeError: 'Відкликання відхилено',
      revokeConfirm: 'Надання припиняється негайно, і завдання знову блокує користувача «trantor» на вузлі: тимчасовий пароль перестає діяти.',
      passwordTitle: 'Пароль лише для читання',
      passwordOnce: 'Цей пароль показується ЛИШЕ один раз: скопіюйте його зараз. Він ніде не зберігається і його не можна буде прочитати знову — якщо ви його втратите, надайте знову.',
      passwordUser: 'Користувач',
      passwordLabel: 'Пароль',
      passwordHint: 'Дійсний до {until} або до наступного перезавантаження вузла; придатний до використання, коли завдання надання завершено. Доступ: ssh trantor@<адреса вузла>.',
      emergencyTitle: 'Останній аварійний доступ (trantor-emergency)',
      lastLogin: '{time} через {via} з {from}',
      lastLoginNone: 'не спостерігалося',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'консоль',
        sudo: 'sudo',
        unknown: 'невідомо'
      },
      emergencyHint: 'Аварійний обліковий запис «trantor-emergency» (повний sudo) завжди увімкнений з паролем, згенерованим під час встановлення вузла і збереженим у сейфі: TVirt його не знає, не ротує і не відновлює. Кожен вхід повідомляється тут і в журналі подій.'
    },
    nodeFirewall: {
      tab: 'Брандмауер',
      title: 'Брандмауер вузлів',
      subtitle: 'Постура ruleset nftables, який кожен вузол застосовує до себе — єдиний брандмауер вузла (firewalld вимкнено)',
      modeLabel: 'Постура',
      mode: {
        disabled: 'Вимкнено — жодного ruleset на вузлах',
        permissive: 'Дозвільна — рахує та записує, нічого не відкидає',
        enforced: 'Застосована — входить лише похідний реєстр'
      },
      hint: {
        disabled: 'Як сьогодні: вузли не несуть жодного ruleset. Перейдіть у дозвільну, щоб ПРОЧИТАТИ, що було б відкинуто, перш ніж це відкидатиметься.',
        permissive: 'Кожен вузол застосовує свій похідний ruleset із policy accept: те, що застосований режим відкинув би, рахується і записується (префікс у журналі «tvirt-node would-drop:»). Ніщо не блокується.',
        enforced: 'Кожен вузол застосовує свій похідний ruleset із policy drop: ssh та API звідусіль, store / live migration / overlay / Ceph лише від учасників, слухачі мережевих сервісів — з мережі, яку вони обслуговують. Кожна зміна — це apply з підтвердженням: вузол, який не зміг підтвердити, відкочується сам.'
      },
      confirmTitle: 'Застосувати брандмауер вузлів?',
      confirmBody: 'Кожен вузол застосовує ruleset із підтвердженням: до закінчення терміну зондує бекенд, store і ssh крізь нові правила й підтверджує — інакше сам відкочується до попереднього ruleset. Спершу прочитайте лічильники дозвільного режиму на вузлах.',
      confirmSubmit: 'Застосувати',
      confirmCancel: 'Скасувати',
      lensTitle: 'Брандмауер вузла',
      loadError: 'Не вдалося завантажити лінзу брандмауера вузла',
      noReport: 'Звіту брандмауера з цього вузла поки немає — worker доповість на наступному проході',
      firewalldActive: 'На цьому вузлі працює firewalld: брандмауер вузла відмовляється застосовуватися поруч із ним (замаскуйте firewalld)',
      conditionUnconfirmed: 'Підтвердженого ruleset поки немає — вузол відкритий',
      conditionRolledBack: 'Останній apply відкотився — та сама генерація не повторюється, доки не зміниться реєстр або не буде знову змінено постуру',
      lastError: 'Остання помилка',
      posture: 'Постура',
      observedAt: 'Спостережено',
      desiredGeneration: 'Бажана генерація',
      componentTitle: 'Компонент вузла',
      componentSubtitle: 'tvirt-node-firewall — при завантаженні застосовує підтверджений ruleset, непідтверджений сам відкочує',
      componentAbsent: 'Компонент ще не доповідав',
      phase: 'Фаза',
      phases: {
        none: 'Ніколи не застосовувався',
        applied: 'Застосовано — очікує підтвердження',
        confirmed: 'Підтверджено',
        rolledBack: 'Відкочено'
      },
      generation: 'Генерація',
      appliedAt: 'Застосовано',
      confirmedAt: 'Підтверджено',
      deadline: 'Термін відкату',
      lastRollback: 'Останній відкат',
      registryTitle: 'Похідний реєстр',
      registrySubtitle: 'Порти, які відкриває цей вузол, за класом і походженням — виведені з кластера, ніколи не редагуються вручну',
      registryEmpty: 'Нічого не виведено — постуру вимкнено без підтвердженого ruleset, або звіту ще немає',
      colClass: 'Клас',
      colPort: 'Порт',
      colSource: 'Джерело',
      colOrigin: 'Походження',
      classes: {
        public: 'Публічний',
        internode: 'Міжвузловий',
        tenant: 'Tenant'
      },
      sourceMembers: 'лише учасники',
      sourceAnywhere: 'звідусіль',
      sourceBridge: 'на {iface}'
    },
    derivationDerived: 'похідний',
    derivationDiverged: 'розбіжний',
    derivationDerivedTip: 'Мережевий документ ПОХІДНИЙ від fabric {fabric} і досі збігається з рендером на поточних входах — клік для плану деривації.',
    derivationDivergedTip: 'Деривація від fabric {fabric} змінилася після останнього apply (fabric, кабелювання, ролі чи посилання) — клік для очікуваного diff.',
    derivationRetiring: {
      one: '{n} адреса осушується',
      few: '{n} адреси осушуються',
      many: '{n} адрес осушуються',
      other: '{n} адреси осушується'
    },
    standaloneHint: 'Цей вузол не має кластера: його ще не встановлено. Кластери створюють АБО приєднуються до них під час встановлення — токен, згенерований у таблиці «Сервери» одного з учасників, згодовують інсталятору (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Ваші права охоплюють scope, а не весь кластер: інвентар парку — вузли, налаштування та пристрої — бачать лише адміністратори кластера.',
    phaseReady: 'Готовий',
    phaseForming: 'Формується',
    storeMembers: 'Учасники сховища конфігурації',
    watermark: 'Поріг збіжності',
    configGeneration: 'Генерація конфігурації',
    converged: 'узгоджено',
    behind: 'відстає — {m} / {n}',
    revision: 'Ревізія',
    rolesTitle: 'Мережеві ролі',
    rolesSubtitle: 'Адреси кожного учасника для кожного класу трафіку — сама зв’язність живе в мережі хоста',
    roleManagement: 'Керування',
    roleLiveMigration: 'Жива міграція',
    roleInherited: 'успадковує керування',
    settingsTitle: 'Налаштування',
    settingsSubtitle: 'Політика безпеки на рівні кластера — кожен вузол обчислює її зі своєї локальної репліки',
    taskRetentionTitle: 'Утримання завдань',
    taskRetentionSubtitle: 'Єдиний GC для всіх завдань — завершені завдання, старші за граничний вік або понад ліміт, прибираються; ті, що виконуються, — ніколи',
    taskRetentionMaxAge: 'Максимальний вік (дні)',
    taskRetentionMaxCount: 'Максимальна кількість завдань',
    eventRetentionTitle: 'Зберігання подій',
    eventRetentionSubtitle: "GC журналу — політика, незалежна від політики завдань: завдання — це черга, подія — це пам'ять",
    eventRetentionMaxAge: 'Максимальний вік (дні)',
    eventRetentionMaxCount: 'Максимум збережених подій',
    spaceThresholdsTitle: 'Пороги місця',
    spaceThresholdsSubtitle: 'Коли сховище, що заповнюється, потрапляє в журнал (і в сповіщення)',
    spaceLowPct: 'Попередження від (% зайнято)',
    spaceCriticalPct: 'Критично від (% зайнято)',
    spaceOrderError: 'Критичний поріг не може бути нижчим за попередження',
    spaceThresholdsHint: 'Налаштовуються лише входи: вихід виводить рушій, на 5 пунктів нижче кожного порогу, щоб сховище на межі ніколи не стало метрономом',
    failoverReserveTitle: 'Резерв відмовостійкості',
    failoverReserveSubtitle: 'Контроль допуску N+1 — RAM, що тримається вільною, щоб кластер міг перезапустити своє навантаження після втрати вузлів',
    failoverReserveTolerate: 'Скільки втрачених вузлів витримувати',
    failoverReserveOff: '0 — резерв вимкнено: жоден запуск ніколи не відхиляється через ємність відмовостійкості',
    failoverReserveOn: 'Запуск, який зачепив би резерв, відхиляється з відповіддю 412, що пояснює числа',
    networkShapingTitle: 'Справедливість смуги',
    networkShapingSubtitle: 'Три типологічні ваги дерева shaping на кожен uplink — діють лише за конкуренції',
    networkShapingRest: 'Вага решти (площина керування, storage, репліки)',
    networkShapingOverlay: 'Вага overlay-мереж',
    networkShapingLiveMigration: 'Вага live migration',
    networkShapingHint: 'Гарантована частка = вага / сума трьох (типово 300 / 100 / 200, кожна від 1 до 10000); на вільному лінку будь-який клас може зайняти всю смугу',
    debugModeTitle: 'Режим debug',
    debugModeSubtitle:
      'Детальні помилки в загальних сповіщеннях GUI — щоб побачити справжню причину, коли «невдала» дія насправді виконалася успішно',
    debugModeLabel: 'Режим debug увімкнено',
    debugModeOn: 'Загальні сповіщення про помилки дописують приховану причину — внутрішні деталі, видимі кожному оператору',
    debugModeOffHint: 'Вимкнено — загальні сповіщення про помилки лишаються загальними, без внутрішніх деталей',
    nodeDetailsAction: 'Деталі вузла',
    node: {
      docTitle: 'Вузол',
      notFound: 'Вузол не знайдено',
      tabOverview: 'Огляд',
      tabStats: 'Статистика',
      tabNetwork: 'Мережа',
      tabSettings: 'Локальні налаштування',
      identityTitle: 'Ідентичність',
      heartbeatTitle: 'Пульс',
      ysqlPort: 'Порт YSQL',
      revision: 'Ревізія конфігурації',
      versionsTitle: 'Спостережені версії',
      heartbeatSubtitle: 'Останній стан, який вузол повідомив про себе',
      cpuTitle: 'CPU',
      cpuModelTitle: 'Модель CPU',
      memoryTitle: 'Пам’ять',
      hugePagesTitle: 'Величезні сторінки',
      hugePagesPool: '{size}: {free} вільно з {total}',
      hugePagesNone: 'Пулу немає',
      hugePagesNoneHint: 'Вузол не має зарезервованих величезних сторінок: ВМ, які їх просять, не можуть тут стартувати. Пул оголошується на вузлі параметрами ядра hugepagesz і hugepages або записом у nr_hugepages.',
      usageTitle: 'Поточне використання',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'не спостерігається — свіжих вибірок немає',
      statsNoData: 'Немає даних у цьому інтервалі — серії вузла збирає сам вузол, і подаються вони локально.',
      observedTitle: 'Спостережений стан',
      observedSubtitle: 'Служби та ресурси, локальні для вузла, як їх бачить воркер'
    },
    editRolesTitle: 'Змінити мережеві ролі',
    memberNode: 'Вузол',
    memberIp: 'IP-адреса',
    addMember: 'Додати учасника',
    lmInherit: 'Використовувати адреси керування',
    roleIpHint: 'Додавати та вилучати учасників можна вільно; зміна IP наявного учасника на місці відхиляється — процедура міграції IP прийде в наступному раунді.',
    roleError: 'Не вдалося оновити ролі',
    nodesTitle: 'Вузли',
    addNodeTitle: 'Додати вузол до кластера',
    addNode: 'Додати вузол',
    addNodeError: 'Не вдалося попередньо зареєструвати вузол',
    nodeName: 'Назва вузла',
    nodeNameHint: 'має збігатися з назвою, обраною під час встановлення',
    nodeIp: 'IP керування',
    colName: 'Назва',
    colPhase: 'Фаза',
    colServices: 'Служби',
    colWatermark: 'Поріг',
    colLastSeen: 'Останній контакт',
    colUps: 'ДБЖ',
    upsCordonChip: 'кордон ДБЖ',
    upsCordonTip: 'Вузол засудив себе за фактами свого ДБЖ ({time}): він сам зніме кордон, коли мережа стане стабільною, а батарея зарядиться',
    upsUnreachable: 'ДБЖ недоступний',
    upsOnBattery: 'Від батареї',
    upsOnLine: 'Від мережі',
    upsLowBattery: 'низький заряд',
    upsNoEstimateChip: 'автономність не оцінена',
    upsNoEstimateTip: 'ДБЖ не публікує оцінку автономності: вузол засуджується лише прапорцем LB (низький заряд) ДБЖ — налаштуйте battery.runtime.low / LB на самому ДБЖ',
    upsLaneTip: 'Шлях вимкнення за ДБЖ з {since}: засуджено через {by}',
    upsUnit: 'пристрій',
    upsStatus: 'стан NUT',
    upsLoad: 'навантаження',
    upsOnBatterySince: 'від батареї з',
    upsOnLineSince: 'від мережі з',
    upsError: 'помилка',
    upsObservedAt: 'спостережено',
    upsNone: 'жоден пристрій ДБЖ не обслуговує цей вузол',
    upsBy: {
      runtime: 'автономність нижче порога',
      lowBattery: 'прапорець LB ДБЖ',
    },
    upsLane: {
      evacuate: 'евакуація',
      local: 'вимкнення на місці',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'зупинення гостей',
      stoppingServices: 'зупинення служб',
      poweredOff: 'вимкнено',
    },
    upsTitle: 'ДБЖ (NUT)',
    upsSubtitle: 'Пристрої ДБЖ і пороги: вузол засуджується при автономності ≤ порога або за прапорцем LB (завжди враховується), відновлення з гістерезисом',
    upsRuntimeThreshold: 'Поріг автономності (с)',
    upsRuntimeThresholdHint: 'Від батареї з оціненою автономністю ≤ порога вузол вимикається по порядку (типово 300)',
    upsResumeStable: 'Мережа стабільна протягом (с)',
    upsResumeStableHint: 'Відновлення лише за неперервної мережі щонайменше стільки секунд (типово 60)',
    upsResumeCharge: 'Мінімальний заряд при відновленні (%)',
    upsResumeChargeHint: 'І батарея заряджена щонайменше до цього відсотка (типово 25)',
    upsPolicyNote: 'Прапорець LB (низький заряд) ДБЖ засуджує завжди і не вимикається; порога на час роботи від батареї немає. Кожен пристрій може перевизначити три числа.',
    upsUnitNew: 'новий пристрій',
    upsUnitSelectors: '{n} селектор(ів) за тегами (лише CLI)',
    upsUnitName: 'Назва пристрою',
    upsUnitMode: 'Режим',
    upsModeExternal: 'зовнішній (чужий upsd)',
    upsModeManaged: 'керований (ДБЖ підключено до вузла)',
    upsUnitUpsname: 'Назва NUT (upsname)',
    upsUnitHost: 'Хост upsd',
    upsUnitAttachedNode: 'Підключений вузол',
    upsUnitDriver: 'Драйвер NUT',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Пристрій драйвера',
    upsUnitDeviceHint: 'рядок port= в ups.conf: порожньо = auto',
    upsUnitPort: 'Порт upsd',
    upsUnitServedNodes: 'Обслуговувані вузли',
    upsUnitServedNodesHint: 'назви вузлів через кому (селектори за тегами — через CLI)',
    upsUnitOverrideHint: 'порожньо = типове кластера',
    upsUnitAdd: 'Додати пристрій',
    unreachableSince: 'Недоступний — останній пульс {time}',
    overlaysChip: 'оверлей',
    overlaysBehind: 'Оверлейний dataplane ще не втілив поточну конфігурацію оверлею',
    overlaysError: 'Останній прохід узгодження оверлею завершився невдало: {error}',
    storeChip: 'сховище конфігурації',
    phase: {
      'pending-join': 'Очікує приєднання',
      'joining': 'Приєднується',
      'member': 'Учасник'
    },
    tokenTitle: 'Токен приєднання',
    tokenOnce: 'Показується лише зараз — скопіюйте негайно, прочитати його вдруге не вийде',
    copy: 'Копіювати',
    copied: 'Скопійовано',
    close: 'Закрити',
    revokeTitle: 'Відкликати попередню реєстрацію',
    revoke: 'Відкликати',
    revokeError: 'Не вдалося відкликати реєстрацію',
    promote: 'Підвищити до учасника сховища конфігурації',
    demote: 'Вилучити роль учасника сховища конфігурації',
    troubleshoot: 'Усунення несправностей',
    promoteTitle: 'Підвищити до учасника сховища конфігурації',
    demoteTitle: 'Вилучити роль учасника сховища конфігурації',
    promoteHint: 'Вузол входить до кворуму майстрів YugabyteDB. Справжня HA потребує трьох учасників сховища конфігурації.',
    demoteHint: 'Вузол виходить із кворуму майстрів і зупиняє свої служби сховища конфігурації.',
    storeError: 'Зміну учасника сховища конфігурації відхилено',
    attest: 'Засвідчити вимкненим…',
    attestTitle: 'Засвідчити вузол вимкненим',
    attestSubmit: 'Засвідчити вимкненим',
    attestConfirm: 'Ви оголошуєте цей вузол вимкненим на власний ризик: засвідчення насправді живого вузла загрожує подвійним запуском ВМ. Його завдання позначаються як невдалі, а повноваження над його ВМ стають переносними.',
    attestError: 'Засвідчення відхилено',
    attestedChip: 'засвідчено вимкненим',
    maintenanceChip: 'обслуговування',
    guestToolsChip: 'TVirt Guest Tools (ресурс ISO, локальний для вузла)',
    maintenanceEnter: 'Увімкнути обслуговування',
    maintenanceExit: 'Вимкнути обслуговування',
    maintenanceEnterTitle: 'Увімкнути обслуговування',
    maintenanceExitTitle: 'Вимкнути обслуговування',
    maintenanceEnterSubmit: 'Увімкнути обслуговування',
    maintenanceExitSubmit: 'Вимкнути обслуговування',
    maintenanceEnterConfirm: 'Вузол ізолюється та звільняється: мережеві служби та екземпляри App, authority яких він тримає, переносяться (екземпляри вхолодну: зупинені та зібрані тут, відтворені на цільовому вузлі — простій), запущені VM мігрують наживо, де можливо, інакше коректно зупиняються, поточні задачі завершуються, нова робота чекає, а зупинені VM втрачають свою authority — Proximity розміщує їх знову під час наступного запуску. Після завершення обслуговування ніщо не повертається саме.',
    maintenanceExitConfirm: 'Вузол знову береться до роботи, і Proximity знову враховує його під час розміщення. ВМ повертаються лише тоді, коли їх запускають.',
    maintenanceError: 'Запит на обслуговування відхилено',
    maintenancePlanTitle: 'План евакуації',
    maintenancePlanLoading: 'Обчислення плану евакуації…',
    maintenancePlanError: 'Не вдалося завантажити план евакуації — звільнення все одно мігрує все, що зможе, і зупинить решту.',
    maintenancePlanEmpty: 'На цьому вузлі нічого евакуювати — немає активної мережевої служби, немає екземпляра App, потрібного в роботі, немає запущеної VM.',
    maintenancePlanSummary: "{migrate} об'єктів мігрують (VM, мережеві служби, екземпляри App), {stop} зупиняться або залишаться на місці.",
    maintenancePlanReserve_ok: 'Резерв відмовостійкості після звільнення: цілий — лишається {headroom} GiB, придатних для запуску, з витримкою втрати {n} вузла(-ів).',
    maintenancePlanReserve_eroded: 'Резерв відмовостійкості після звільнення: майже вичерпаний — лишається лише {headroom} GiB із {reserve} GiB, що тримаються вільними на {n} відмову(-и) вузлів.',
    maintenancePlanReserve_exhausted: 'Резерв відмовостійкості після звільнення: ВИЧЕРПАНИЙ — бракує {headroom} GiB із {reserve} GiB, потрібних, щоб витримати {n} відмову(-и) вузлів. Поки цей вузол поза грою, нові запуски ВМ відхилятимуться.',
    maintenancePlanReserve_unknown: 'Резерв відмовостійкості після звільнення: обчислити неможливо — жоден з решти вузлів не задекларував свою пам’ять.',
    maintenancePlanReserveHugePages: 'Величезні сторінки по {size} після звільнення — вільні: {free} з {capacity}, потрібно в резерві: {reserve}.',
    maintenancePlanActionMigrate: 'мігрує',
    maintenancePlanActionMigrateWarning: 'мігрує (порушено м’яке правило)',
    maintenancePlanActionStop: 'зупиниться',
    maintenancePlanActionBlocked: 'заблокована',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'мережева служба',
    maintenancePlanKindApp: 'екземпляр App',
    maintenancePlanColdMove: 'Холодне перенесення: под зупиняється та збирається тут, а worker цільового вузла відтворює його — простій до наступного pass цільового worker.',
    caFingerprint: 'Відбиток CA кластера',
    staleChip: 'не оновлено',
    troubleshootTitle: 'Усунення несправностей сховища конфігурації',
    restartStore: 'Перезапустити служби сховища конфігурації',
    restartHint: 'Якщо сховище конфігурації вередує, перезапустіть його служби. Для досвідчених — застосовувати обережно.',
    restartQueued: 'Завдання перезапуску поставлено в чергу',
    restartError: 'Не вдалося перезапустити служби',
    svcActive: 'активна',
    svcWanted: 'бажана, не активна',
    svcStopped: 'зупинена',
    noServices: 'Не повідомлено про жодну службу'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'Інвентар GPU всього кластера, згрупований за моделлю — плати, спостережені на кожному вузлі, з позначеними реєстраціями та їхніми тегами',
    usbTitle: 'Ресурси USB',
    usbSubtitle: 'Інвентар USB всього кластера, згрупований за моделлю — пристрої, спостережені на кожному вузлі, з реєстраціями обох моделей (за пристроєм, за портом) та їхніми тегами',
    markedChip: '{n} придатних для TVirt',
    orphanChipGpu: '{n} осиротілих',
    orphanChipUsb: '{n} осиротілих пристроїв',
    colNode: 'Вузол',
    colRegistration: 'Реєстрація',
    noRegsHint: 'Реєстрацій немає — пристрій позначають «придатним для TVirt» у діалозі вузла (Вузли › вузол › Налаштування).',
    colDevice: 'Пристрій',
    colObserved: 'Спостережені',
    colRegs: 'Реєстрації',
    regsNone: 'немає',
    colPci: 'Адреса PCIe',
    colIdentity: 'Ідентичність / порт',
    colClasses: 'Класи (теги)',
    colActions: 'Дії',
    manageOnNode: 'Керувати на вузлі {node} (позначення живе в діалозі вузла)',
    introTitle: 'Інвентар кластера з пристроїв USB і PCIe, придатних для TVirt©.',
    introStep1: '1. Вузли самі виявляють свої GPU та пристрої USB (перепис у пульсі).',
    introStep2: '2. Пристрій позначають «придатним для TVirt» у діалозі ВУЗЛА (Вузли › вузол › Налаштування) — позначення прив’язує його до vfio і реєструє тут.',
    introStep3: '3. Тут ви надаєте реєстраціям їхні КЛАСИ через теги (напр. gpu_class=compute): вимоги ВМ проситимуть клас, а планувальник обере вузол із вільним сумісним пристроєм.',
    colMode: 'Режим',
    colState: 'Стан',
    colNotes: 'Нотатки',
    colTags: 'Теги',
    modeDevice: 'за пристроєм',
    modePort: 'за портом',
    usable: 'придатний',
    orphanGpu: 'осиротіла',
    orphanUsb: 'осиротілий',
    hubChip: 'хаб',
    orphanPortsTitle: 'Реєстрації за портом без під’єднаного пристрою — під’єднайте пристрій знову або зніміть з них позначку на вузлі',
    gpusEmpty: 'Жодної GPU ще не спостережено на жодному вузлі',
    usbEmpty: 'Жодного пристрою USB ще не спостережено на жодному вузлі'
  },

  // Спільний словник форм налаштувань (рефакторинг 2026-07-24): поля безпеки
  // живлять картку сторінки «Кластер», поля вузла — сторінку node-settings;
  // сторінка /system/settings, заради якої вони народилися, померла.
  settings: {
    passwordMinLength: 'Мінімальна довжина пароля',
    sessionIdle: 'Тайм-аут бездіяльності сесії (хвилини)',
    lockoutThreshold: 'Блокування після невдалих спроб',
    lockoutDuration: 'Тривалість блокування (хвилини)',
    keyboardLayout: 'Розкладка клавіатури',
    keyboardLayoutHint: 'напр. it, en-us — порожньо для типової розкладки QEMU',
    syslogEndpoint: 'Кінцева точка syslog',
    syslogEndpointHint: 'хост:порт — порожньо, щоб вимкнути пересилання',
    syslogTls: 'TLS',
    maxQueued: 'Максимум завдань у черзі',
    concurrency: 'Паралельність воркера',
    concurrencyHint: 'Застосовується воркером на льоту',
    notesTitle: 'Нотатки',
    save: 'Зберегти',
    saved: 'Налаштування збережено',
    saveError: 'Не вдалося зберегти налаштування'
  },
  localSettings: {
    derivedChip: 'похідний',
    derivedTip: 'Цей device НАЛЕЖИТЬ деривації fabric (H2): редактор відмовляється його торкатися — змініть fabric (або кабелювання) і застосуйте знову, або заберіть його нижче.',
    takeOwnership: 'Взяти у володіння',
    takeOwnershipTitle: 'Взяти у володіння (take-ownership)',
    takeOwnershipConfirm: '{name} покидає блок fabric і знову стає РУЧНИМ device, яким править цей редактор. Вузол стає розбіжним, і наступний apply деривації відмовить на ньому (manualConflict), доки ви його не перейменуєте чи не видалите — або не виправите fabric.',
    nodeSettingsTitle: 'Налаштування вузла',
    nodeSettingsSubtitle: 'Те, що застосовує цей вузол — черга завдань, консоль, пересилання журналів — плюс його теги та нотатки',
    baseTitle: 'Резерви хоста (TVirt Proximity)',
    baseSubtitle: 'CPU та RAM, зарезервовані для операційної системи хоста — вхідні дані емпіричної ємності, за якою Proximity розміщує ВМ',
    baseMemory: 'Базова RAM (MiB)',
    baseMemoryHint: 'Спостережено загалом: {total} MiB. Доступно для ВМ = загалом − база − RAM увімкнених ВМ, розміщених тут.',
    baseMemoryHintNoTotal: 'Доступно для ВМ = спостережений загальний обсяг − база − RAM увімкнених ВМ, розміщених тут.',
    baseCpu: 'Базові ядра CPU',
    baseCpuHint: 'Спостережені логічні CPU: {total}. Використовуються лише як вага ранжування — оверкоміт vCPU є нормою.',
    baseCpuHintNoTotal: 'Використовуються лише як вага ранжування — оверкоміт vCPU є нормою.',
    baseHint: 'RAM — це жорсткий бар’єр допуску: ВМ, яка не вміщується в доступну RAM, відхиляється зі змістовною помилкою. Підніміть базу на хостах, що тримають учасників сховища конфігурації або демонів Ceph.',
    placementTitle: 'Фізичне розташування',
    placementSubtitle: 'Де фізично стоїть цей сервер — оголошується один раз, для всього, чому це знадобиться',
    placementHint: 'Розташування керує ієрархією CRUSH кожного кластера Ceph, що має OSD на цьому сервері: збереження зміни перевирівнює їхні мапи через завдання (хост → стійка → … → корінь). Часткові оголошення дозволені — порожні рівні згортаються. Назви спільні для всієї мапи: два сервери в одній стійці оголошують ту саму назву стійки.',
    placementNameInvalid: 'Назва, безпечна для DNS (малі літери, цифри, дефіси)',
    placementEmpty: 'Порожньо = не оголошено',
    placementLevel: {
      chassis: 'Шасі',
      rack: 'Стійка',
      row: 'Ряд',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Кімната',
      datacenter: 'Дата-центр',
      zone: 'Зона',
      region: 'Регіон'
    },
    cablingTitle: 'Кабелювання',
    cablingSubtitle: 'До якого порту комутатора під’єднано кожен інтерфейс — оголошення живе на вузлі (Annex O.9)',
    cablingHint: 'Один кабель на NIC, один кабель на порт по всьому флоту (API відхиляє, називаючи власника). Кабелювати до порту, що є учасником LAGG, дозволено — це випадок бонда: майбутнє виведення покаже його як LACP.',
    cablingInterface: 'Інтерфейс',
    cablingNotCabled: '— не під’єднано —',
    cablingNoInterfaces: 'Не спостережено жодного мережевого інтерфейсу',
    disksTitle: 'Диски',
    disksSubtitle: 'Спостережені блокові пристрої — одне сканування на прохід узгодження; позначте тут диски, придатні як OSD Ceph (N.15: придатність оголошується явно)',
    colDataDisk: 'Диск даних',
    dataDisksHint: 'Позначка на пристрої оголошує його придатним як OSD; серійний номер — це його ідентифікаційний якір: копіюється з обладнання, коли диск його повідомляє, і карбується (tvirt-…) в іншому разі. Діалог реєстрації Ceph пропонує лише оголошені диски.',
    diskDeclaredSerial: 'оголошено',
    diskNotObserved: 'оголошено, але не спостережено — під’єднайте пристрій знову або зніміть позначку',
    noDisks: 'Жодного блокового пристрою ще не спостережено',
    colSerial: 'Серійний номер',
    colModel: 'Модель',
    colSize: 'Розмір (GiB)',
    colDiskType: 'Тип',
    colInUse: 'У використанні',
    colObservedAt: 'Спостережено',
    diskInUse: 'у використанні',
    diskFree: 'вільний',
    diskMounted: 'змонтований',
    diskPartitions: 'розділи',
    passthroughTitle: 'Наскрізні пристрої',
    passthroughSubtitle: 'Спостережені GPU та пристрої USB — позначте тут, що саме TVirt може передавати у ВМ; позначення реєструє ідентичність пристрою (раунд U1+G1)',
    passthroughHint: 'Позначення реєструє пристрій (стабільний ідентифікатор — ціль тегів і вимог до класу). У позначеної GPU ЦІЛА група IOMMU прив’язується до vfio-pci одним махом — вона одразу залишає хост; знята позначка повертає рідний драйвер. Для USB чинні обидві ратифіковані моделі: за пристроєм (виробник+продукт, хоч би куди його встромили) і за фізичним портом (у ВМ потрапляє все, що в нього вставлять). USB не прив’язується під час позначення — під’єднання відбувається під час роботи ВМ.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Придатний для TVirt',
    colGpu: 'GPU',
    colPciAddress: 'Адреса PCI',
    colDriver: 'Драйвер',
    colVerdict: 'Вердикт',
    gpuEligible: 'Відповідає',
    gpuIneligible: 'Не відповідає',
    gpuReason: {
      'no-iommu': 'IOMMU не активний на хості',
      'group-spans-slots': 'група IOMMU не ізольована: охоплює інші слоти',
      'multiple-display': 'група IOMMU не ізольована: більш ніж одна відеофункція',
      'foreign-function': 'група IOMMU не ізольована: містить сторонню функцію'
    },
    vfioNotReady: 'IOMMU не активний на цьому хості: жодна GPU не відповідає вимогам, доки платформа хоста його не ввімкне (OEM-ISO) — TVirt ніколи не чіпає аргументи ядра під час роботи.',
    vfioMissingKernelArg: 'IOMMU не активний на цьому хості: мікропрограма повідомляє про VT-d/AMD-Vi (таблиця ACPI DMAR/IVRS присутня), але бракує аргументу ядра — додайте intel_iommu=on (Intel) або приберіть amd_iommu=off (AMD) з командного рядка ядра і перезавантажте. TVirt ніколи не чіпає аргументи ядра під час роботи.',
    vfioFirmwareDisabled: 'IOMMU не активний на цьому хості: VT-d/AMD-Vi вимкнено в мікропрограмі (немає таблиці ACPI DMAR/IVRS) або CPU його не підтримує — увімкніть його в налаштуваннях мікропрограми, жоден аргумент ядра його не ввімкне. TVirt ніколи не чіпає хост під час роботи.',
    gpuBindError: 'Не вдалося прив’язати vfio-pci на {address}: {error}',
    firewallBridgesTitle: 'Брандмауер на некерованих бриджах',
    firewallBridgesSubtitle: 'Зібрані вручну бриджі цього вузла, чиє налаштування погоджується на ланцюжки брандмауера, які TVirt рендерить на підключених гостьових NIC',
    firewallBridgesHint: 'TVirt ніколи не чіпає чужий бридж — ланцюжок кріпиться на tap/veth, який завжди належить TVirt. Список — це брама згоди: default-deny та антиспуфінг можуть зламати те, чого очікує ручне налаштування, тож гостьова NIC із брандмауером на некерованому бриджі, НЕ переліченому тут, відхиляється зі змістовною помилкою.',
    firewallBridgesEmpty: 'Жоден некерований бридж не погоджується на ланцюжки брандмауера, які TVirt рендерить на цьому вузлі.',
    firewallBridgeAdd: 'Додати бридж',
    firewallBridgeInvalid: 'Це не назва інтерфейсу Linux (1-15 символів, без слеша та пробілів)',
    firewallBridgeDuplicate: 'Назва вже в списку',
    colMarkDevice: 'За пристроєм',
    colMarkPort: 'За портом',
    usbHub: 'хаб',
    colUsbId: 'Виробник:Продукт',
    colPort: 'Порт',
    passthroughOrphan: 'осиротілий — зареєстрований, але більше не виявляється: під’єднайте його знову або зніміть позначку',
    noGpus: 'Жодної GPU ще не спостережено',
    noUsb: 'Жодного пристрою USB ще не спостережено',
    networkGeneration: 'Генерація мережі',
    applied: 'Застосована',
    converged: 'узгоджено',
    behind: 'відстає — {m} / {n}',
    notConfigured: 'не налаштовано',
    rollbackBody: 'Не вдалося застосувати генерацію {gen}: {error}',
    rolledBackChip: 'відкат виконано',
    nicsTitle: 'NIC',
    nicsSubtitle:
      'Реєстр керованих NIC — реєстрація Є декларацією керування: зареєстровану NIC без конфігурації ніхто не чіпає (clear-if оголошує її явно чистою), а незареєстрований пристрій не чіпають ніколи',
    addNic: 'Зареєструвати NIC',
    addNicTitle: 'Зареєструвати NIC (add-nic)',
    delNic: 'Припинити керування',
    delNicTitle: 'Припинити керування (del-nic)',
    delNicConfirm:
      'Керування {name} припиняється: запис реєстру та його конфігурацію буде видалено, а профіль TVirt вилучено — пристрій лишиться таким, яким його тримає Linux.',
    nicName: 'Назва пристрою',
    nicMac: 'Постійна MAC-адреса',
    nicMacHint: 'постійна апаратна MAC — стабільна ідентичність, зафіксована TVirt Server Installer',
    colObserved: 'Спостережена',
    nicObserved: 'спостережена',
    nicNotObserved: 'не спостережена',
    nicMacMismatch: 'MAC розбігається — спостережено {mac}',
    noNics: 'Не зареєстровано жодної NIC — зареєструйте пристрій, щоб почати ним керувати',
    noManagedDevices: 'Немає керованих пристроїв — спершу зареєструйте NIC, усе будується на реєстрі',
    inventoryTitle: 'Спостережені пристрої',
    inventorySubtitle: 'Оновлюються за кожного проходу узгодження воркером вузла — валідація звіряє назви пристроїв із цим інвентарем',
    colDevice: 'Пристрій',
    colType: 'Тип',
    colMac: 'MAC',
    colLink: 'Лінк',
    colSpeed: 'Швидкість',
    colTopology: 'Топологія',
    colMtu: 'MTU',
    colAddresses: 'Адреси',
    linkUp: 'активний',
    linkDown: 'неактивний',
    lacpDegraded: 'LACP не агрегує',
    noInventory: 'Досі не повідомлено про жоден пристрій',
    interfacesTitle: 'Інтерфейси',
    interfacesSubtitle:
      'Конфігурація L3 зареєстрованих NIC та оголошених логічних пристроїв — set-if замінює блок цілком, edit-if підправляє властивості, clear-if його спорожнює (явне очищення)',
    colConfig: 'Бажана конфігурація',
    clean: 'чиста',
    setIf: 'Змінити адресацію',
    setIfTitle: 'Змінити адресацію (set-if)',
    editIf: 'Змінити властивості',
    editIfTitle: 'Змінити властивості (edit-if)',
    clearIf: 'Спорожнити конфігурацію',
    clearIfTitle: 'Спорожнити конфігурацію (clear-if)',
    clearIfConfirm: 'Конфігурацію інтерфейсу буде спорожнено. Чистий інтерфейс — це передумова, щоб підпорядкувати його як учасника бонда чи бриджа або як батьківський для VLAN.',
    ip4Mode: 'Режим IPv4',
    ip6Mode: 'Режим IPv6',
    modeUnconfigured: 'Не налаштовано',
    modeStatic: 'Статична',
    modeDhcp: 'DHCP',
    ip4Addresses: 'Адреси IPv4',
    ip6Addresses: 'Адреси IPv6',
    addressesHint: 'CIDR, через кому',
    gw4: 'Шлюз IPv4',
    gw6: 'Шлюз IPv6',
    dns: 'Сервери DNS',
    dnsHint: 'через кому — порожньо обнуляє DNS (set-if замінює блок)',
    routes4: 'Статичні маршрути IPv4',
    routes6: 'Статичні маршрути IPv6',
    routeTo: 'Призначення (CIDR)',
    routeVia: 'Через',
    addRoute: 'Додати маршрут',
    routesChip: 'маршрути',
    mtu: 'MTU',
    mtuHint: 'порожньо = типове значення драйвера',
    vlansTitle: 'VLAN',
    addVlan: 'Додати VLAN',
    addVlanTitle: 'Додати VLAN (add-vlan)',
    delVlanTitle: 'Видалити VLAN (del-vlan)',
    vlanParent: 'Батьківський інтерфейс',
    vlanId: 'ID VLAN',
    vlanPreview: 'Назва пристрою',
    colParent: 'Батьківський',
    colVlanId: 'ID',
    noVlans: 'Не оголошено жодної VLAN',
    bondsTitle: 'Бонди',
    addBond: 'Додати бонд',
    addBondTitle: 'Додати бонд (add-bond)',
    editBondTitle: 'Змінити бонд',
    editBond: 'Зберегти бонд',
    delBondTitle: 'Видалити бонд (del-bond)',
    bondName: 'Назва бонда',
    members: 'Учасники',
    membersHint: 'учасниками мають бути чисті інтерфейси (без конфігурації L3)',
    bondMode: 'Режим',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (мс)',
    primary: 'Основний учасник',
    rate: 'Частота LACP',
    hash: 'Політика хешування під час передавання',
    colMembers: 'Учасники',
    colMode: 'Режим',
    noBonds: 'Не оголошено жодного бонда',
    bridgesTitle: 'Бриджі',
    addBridge: 'Додати бридж',
    addBridgeTitle: 'Додати бридж (add-bridge)',
    editBridgeTitle: 'Змінити бридж',
    editBridge: 'Зберегти бридж',
    delBridgeTitle: 'Видалити бридж (del-bridge)',
    bridgeName: 'Назва бриджа',
    stp: 'STP',
    stpOn: 'STP увімкнено',
    stpOff: 'STP вимкнено',
    colStp: 'STP',
    noBridges: 'Не оголошено жодного бриджа',
    hostnameTitle: 'Ім’я хоста',
    hostname: 'Ім’я хоста',
    setHostname: 'Задати ім’я хоста',
    setHostnameTitle: 'Задати ім’я хоста (set-hostname)',
    hostnameHint: 'Лише ідентичність ОС — назву вузла в кластері це не чіпає',
    notSet: 'не задано',
    staticHostsTitle: 'Статичні записи імен хостів',
    addStaticHost: 'Додати запис',
    addStaticHostTitle: 'Додати статичний запис імені хоста',
    delStaticHostTitle: 'Видалити статичний запис імені хоста',
    hostIp: 'IP-адреса',
    hostNames: 'Імена',
    hostNamesHint: 'через кому або пробіл',
    colIp: 'IP',
    colNames: 'Імена',
    noStaticHosts: 'Статичних записів імен хостів немає',
    delConfirm: 'Вилучення {name} з бажаного документа — воркер вузла виконує збіжність із контрольною точкою NetworkManager та автоматичним відкатом.',
    remove: 'Вилучити',
    opError: 'Мережеву операцію відхилено'
  }
}
